import React, { useState } from "react";
import { ChevronDown, HelpCircle } from "lucide-react";

const FAQS = [
  {
    q: "Gulyan Checker nasıl çalışır?",
    a: "Sistemimizde depolanan sızdırılmış veri kayıtları arasında Discord ID veya diğer platformların kullanıcı adı/ID'si üzerinden derin tarama yaparız. Her sorgu limitiniz dahilinde saniyeler içinde sonuç döner.",
  },
  {
    q: "Verilerimin gizliliği güvende mi?",
    a: "Şifreleriniz bcrypt ile hashlenir, oturumlar JWT + httpOnly cookie ile korunur. Sorgu geçmişiniz sadece size görünür; hesabınızı silerseniz kişisel verileriniz sistemden kaldırılır.",
  },
  {
    q: "Neden sadece BTC ile ödeme?",
    a: "Bitcoin ödemeleri anonimliği korur ve chargeback riski taşımaz. Üyelik satın alma akışında BTC adresine gönderim yapıp TXID'yi girmeniz yeterli — admin onayı sonrası üyeliğiniz anında aktifleşir.",
  },
  {
    q: "Günlük sorgu limitim doldu, ne yapmalıyım?",
    a: "Üyeliğinizi yükselterek limitinizi artırabilirsiniz. Free planda 5, Bronze 50, Silver 200 ve Gold planda sınırsız sorgu hakkı vardır. Limit her gün UTC 00:00'da yenilenir.",
  },
  {
    q: "Sorgu sonuçları ne kadar günceldir?",
    a: "Sistem yöneticileri düzenli olarak yeni veri setleri yükler. Her platform (Discord, Instagram, TikTok vb.) için ayrı ayrı güncelleme yapılır; toplam kayıt sayısını Panel'de görebilirsiniz.",
  },
  {
    q: "Hangi platformları destekliyorsunuz?",
    a: "Discord (aktif), Instagram, Snapchat, TikTok, Facebook, GitHub, Telegram ve Twitter/X. Yeni platformlar admin panelinden veri yüklendikçe otomatik olarak sorgulanabilir hale gelir.",
  },
];

function Item({ q, a, open, onToggle, idx }) {
  return (
    <div
      className={`border border-[#1a1a1a] rounded-xl overflow-hidden transition-colors ${
        open ? "border-[#9D4EDD]/40 bg-[#0a0a0a]" : "bg-[#080808]"
      }`}
      data-testid={`faq-item-${idx}`}
    >
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between gap-3 px-4 py-3.5 text-left"
        data-testid={`faq-toggle-${idx}`}
      >
        <span className="font-heading text-sm md:text-[15px] font-semibold text-white">
          {q}
        </span>
        <ChevronDown
          size={16}
          className={`shrink-0 transition-transform duration-300 ${
            open ? "rotate-180 text-[#9D4EDD]" : "text-[#A1A1AA]"
          }`}
        />
      </button>
      <div
        className="grid transition-[grid-template-rows] duration-400 ease-out"
        style={{ gridTemplateRows: open ? "1fr" : "0fr" }}
      >
        <div className="min-h-0 overflow-hidden">
          <p className="px-4 pb-4 pt-0 text-[13px] text-[#A1A1AA] leading-relaxed">{a}</p>
        </div>
      </div>
    </div>
  );
}

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section className="gc-card p-5" data-testid="faq-section">
      <div className="flex items-center gap-2 mb-1">
        <HelpCircle size={14} className="text-[#9D4EDD]" />
        <div className="gc-label">SSS</div>
      </div>
      <div className="font-heading text-xl font-bold mb-4">
        Sıkça <span className="text-[#9D4EDD]">Sorulan</span> Sorular
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {FAQS.map((f, i) => (
          <Item
            key={i}
            idx={i}
            q={f.q}
            a={f.a}
            open={open === i}
            onToggle={() => setOpen(open === i ? -1 : i)}
          />
        ))}
      </div>
    </section>
  );
}
